import type { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';

export const LoginSkeleton: FC = () => (
    <div className="flex h-full w-full justify-center bg-slt-grey-light">
        <div className="mx-4 mb-8 mt-12">
            <Skeleton h="2rem" w="24rem" />
            <div className="mt-8 flex flex-col gap-8 md:flex-row">
                <div className="flex-1 md:w-[464px] lg:w-[528px]">
                    <Skeleton h="20rem" />
                </div>
                <div className="flex-1 md:w-[464px] lg:w-[528px]">
                    <Skeleton h="16rem" />
                </div>
            </div>
        </div>
    </div>
);
